import { Popover } from 'antd';
import 'antd/es/popover/style/index';
import './index.less';

export default Popover;
